import React from 'react'

import PropTypes from 'prop-types'

import { CardContent, Grid } from '@material-ui/core'
import EmpCard from './EmpCard/EmpCard'
import Pagination from '../../../../UI/Pagination/Pagination'
import PleaseFilter from '../../../../PleaseFilter/PleaseFilter'

const cardContainer = ({
  empRecords,
  copyButtonClicked,
  pagination,
  pageChanged,
  perPageChanged,
  selectedEmps,
  selectedResults,
  empCheckboxChanged,
  deleteButtonClicked,
  filtered,
  pagePermission
}) => {
  const cards = empRecords.map(record => (
    <EmpCard
      key={record.emp_detail_id}
      recordData={record}
      copyButtonClicked={() => copyButtonClicked(record.result_id)}
      actionButtonDisabled={!record.result_id}
      empCheckboxChanged={() => empCheckboxChanged(record.emp_detail_id, record.result_id)}
      deleteButtonClicked={() => deleteButtonClicked(record.result_id)}
      checked={
        selectedEmps.includes(record.emp_detail_id) || selectedResults.includes(record.result_id)
      }
      pagePermission={pagePermission}
    />
  ))
  let content = <PleaseFilter />
  if (filtered) {
    content = (
      <React.Fragment>
        <Grid container spacing={1} justify={'flex-start'}>
          {cards}
        </Grid>
        <Pagination
          pagination={pagination}
          pageChanged={pageChanged}
          perPageChanged={perPageChanged}
        />
      </React.Fragment>
    )
  }

  return <CardContent>{content}</CardContent>
}

cardContainer.propTypes = {
  empRecords: PropTypes.array.isRequired
}

export default cardContainer
